var _defs, _path, _g, _path2, _text, _g2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLi3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 446.802,
    height: 111.109,
    viewBox: "0 0 446.802 111.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1364",
    "data-name": "Rectangle 1364",
    width: 36.267,
    height: 36.266,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1363",
    "data-name": "Rectangle 1363",
    width: 83.485,
    height: 83.485,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1319",
    "data-name": "Group 1319",
    transform: "translate(-149 -2910.363)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M390.142,206.736h-258.6A55.554,55.554,0,0,0,75.992,262.29v0a55.554,55.554,0,0,0,55.554,55.553h258.6a22.629,22.629,0,0,0,17.323-8.069l32.315-38.445a14.047,14.047,0,0,0,0-18.081l-32.315-38.445a22.629,22.629,0,0,0-17.323-8.069",
    transform: "translate(131.309 2703.627)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935",
    transform: "translate(559.535 2948.665)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M324.188,247.914a18.133,18.133,0,1,1-18.133-18.133,18.134,18.134,0,0,1,18.133,18.133",
    transform: "translate(-287.92 -229.782)",
    fill: "#ff8206"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M310.1,243.9a8.058,8.058,0,1,1-8.059-8.058A8.059,8.059,0,0,1,310.1,243.9",
    transform: "translate(275.627 2722.897)",
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Integrates_with_ERP_Accounts_software_etc",
    "data-name": "Integrates with ERP,  Accounts software etc",
    transform: "translate(262 2965)",
    fontSize: 20,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Integrates with ERP, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "Accounts software etc"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1315",
    "data-name": "Group 1315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932",
    transform: "translate(149 2923)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M124.322,256.3A41.743,41.743,0,1,1,82.58,214.558,41.741,41.741,0,0,1,124.322,256.3",
    transform: "translate(-40.836 -214.558)",
    fill: "#ff8206"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M103.534,250.379A26.877,26.877,0,1,1,76.657,223.5a26.877,26.877,0,0,1,26.877,26.877",
    transform: "translate(114.22 2714.498)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M6.913,22.543a.38.38,0,0,1,0-.761h9.065a.38.38,0,0,1,0,.761Zm21.325,11.15H12.065a1.229,1.229,0,0,0-1.224,1.225v1.224H29.462V34.918a1.229,1.229,0,0,0-1.224-1.224ZM5,26.3v2.584H35.3V26.3ZM35.3,7.567H5V25.539H35.3ZM23.414,29.645H16.89l-.774,3.287h8.071l-.774-3.287Zm-13.17-19a4.318,4.318,0,0,1,.492-.168l.113-.816a.38.38,0,0,1,.38-.356h1.384a.379.379,0,0,1,.376.328l.116.842a4.434,4.434,0,0,1,.492.17,4.333,4.333,0,0,1,.467.228l.661-.5a.38.38,0,0,1,.514.022l.49.49.489.489h0a.38.38,0,0,1,.034.5l-.511.676a4.343,4.343,0,0,1,.4.96l.816.113a.38.38,0,0,1,.354.379v.692h0v.671a.379.379,0,0,1-.327.4l-.842.116a4.364,4.364,0,0,1-.168.492,4.271,4.271,0,0,1-.228.467l.5.662a.38.38,0,0,1-.022.514l-.492.49-.49.489h0a.38.38,0,0,1-.5.034l-.679-.514a4.21,4.21,0,0,1-.467.228,4.344,4.344,0,0,1-.492.168l-.113.816a.38.38,0,0,1-.379.354H11.92v0h-.671a.379.379,0,0,1-.4-.327l-.116-.842a4.278,4.278,0,0,1-.492-.17,4.187,4.187,0,0,1-.467-.228l-.662.5A.38.38,0,0,1,8.6,18.99L8.111,18.5l-.49-.49h0a.38.38,0,0,1-.034-.5l.514-.679a4.288,4.288,0,0,1-.4-.959l-.842-.116h0a.379.379,0,0,1-.327-.375V14.02a.379.379,0,0,1,.327-.4l.842-.116a4.347,4.347,0,0,1,.17-.492,4.444,4.444,0,0,1,.228-.468l-.5-.662a.38.38,0,0,1,.022-.514l.49-.489.489-.49h0a.38.38,0,0,1,.5-.034l.679.514a4.307,4.307,0,0,1,.467-.228Zm.911.508h0a.38.38,0,0,0,.3-.32l.106-.768h.723l.1.753a.38.38,0,0,0,.3.334,3.582,3.582,0,0,1,.62.194,3.632,3.632,0,0,1,.551.285.38.38,0,0,0,.461,0l.619-.469.256.256.256.256-.468.619h0a.38.38,0,0,0-.016.434,3.6,3.6,0,0,1,.5,1.2h0a.379.379,0,0,0,.319.3l.768.106v.362h0v.362l-.754.1a.38.38,0,0,0-.335.3,3.581,3.581,0,0,1-.193.62,3.651,3.651,0,0,1-.285.552.379.379,0,0,0,0,.461l.468.619-.256.256-.256.256-.616-.468h0a.378.378,0,0,0-.433-.016,3.625,3.625,0,0,1-.578.3,3.552,3.552,0,0,1-.62.193h0a.38.38,0,0,0-.3.319l-.106.768h-.724l-.1-.754a.379.379,0,0,0-.3-.334,3.636,3.636,0,0,1-1.172-.476.379.379,0,0,0-.461,0l-.616.468-.256-.256-.256-.256.469-.619h0a.379.379,0,0,0,.016-.433,3.633,3.633,0,0,1-.5-1.2h0a.38.38,0,0,0-.32-.3l-.769-.107V14.33l.754-.1a.379.379,0,0,0,.334-.3A3.6,3.6,0,0,1,8.87,12.74a.38.38,0,0,0-.008-.446l-.469-.619.256-.256.256-.256.619.469h0a.379.379,0,0,0,.433.016,3.633,3.633,0,0,1,1.2-.5ZM10.1,12.869a2.578,2.578,0,1,1-.755,1.823,2.578,2.578,0,0,1,.755-1.823Zm1.823.006a1.818,1.818,0,1,1-1.285.532A1.818,1.818,0,0,1,11.92,12.875ZM24.6,16.827a.381.381,0,1,1,.539-.539l.768.768L27.2,15.465a.379.379,0,1,1,.588.478l-1.539,1.895a.348.348,0,0,1-.044.053.38.38,0,0,1-.539,0L24.6,16.827Zm-.757-5.807a6.074,6.074,0,0,1,.789-.265l.178-1.287a.381.381,0,0,1,.379-.354h1.982a.38.38,0,0,1,.376.328l.181,1.313a6.128,6.128,0,0,1,.789.265,6.022,6.022,0,0,1,.745.37l1.042-.789a.38.38,0,0,1,.514.022l.7.7.7.7h0a.38.38,0,0,1,.034.5l-.8,1.059a6.06,6.06,0,0,1,.636,1.534l1.313.181h0a.378.378,0,0,1,.327.375v1.961a.379.379,0,0,1-.327.4l-1.313.181a6.046,6.046,0,0,1-.636,1.534l.788,1.041a.38.38,0,0,1-.022.514l-.7.7-.7.7h0a.38.38,0,0,1-.5.034l-1.058-.8a6.034,6.034,0,0,1-1.533.637l-.178,1.287a.381.381,0,0,1-.379.354H25.215a.379.379,0,0,1-.4-.327l-.181-1.313a6.035,6.035,0,0,1-1.533-.637l-1.042.789a.38.38,0,0,1-.514-.022l-.7-.7-.7-.7h0a.38.38,0,0,1-.034-.5l.8-1.058a5.993,5.993,0,0,1-.37-.744,6.061,6.061,0,0,1-.265-.789l-1.287-.178a.38.38,0,0,1-.355-.379v-.991h0v-.97a.379.379,0,0,1,.327-.4l1.313-.181a6.051,6.051,0,0,1,.636-1.534l-.788-1.041a.38.38,0,0,1,.022-.514l.7-.7.7-.7h0a.38.38,0,0,1,.5-.034l1.058.8a6.069,6.069,0,0,1,.745-.37Zm1.208.415h0a.379.379,0,0,0,.3-.319l.172-1.241h1.321l.168,1.226a.38.38,0,0,0,.3.335,5.3,5.3,0,0,1,.919.286,5.369,5.369,0,0,1,.827.429.38.38,0,0,0,.462,0l1-.757.467.467.467.467-.757,1h0a.38.38,0,0,0-.017.434,5.32,5.32,0,0,1,.734,1.771h0a.38.38,0,0,0,.319.3L32.977,16v1.321l-1.228.168a.379.379,0,0,0-.334.3,5.313,5.313,0,0,1-.727,1.758A.38.38,0,0,0,30.7,20l.757,1-.467.467-.467.467-1-.757h0a.378.378,0,0,0-.433-.016,5.364,5.364,0,0,1-1.771.733h0a.379.379,0,0,0-.3.319l-.172,1.241H25.524l-.168-1.228a.38.38,0,0,0-.3-.334,5.351,5.351,0,0,1-1.743-.715.38.38,0,0,0-.462,0l-1,.757-.467-.467-.467-.467.757-1h0a.379.379,0,0,0,.016-.433,5.355,5.355,0,0,1-.733-1.771h0a.38.38,0,0,0-.319-.3L19.4,17.321v-.657h0V16l1.228-.168a.38.38,0,0,0,.334-.3,5.32,5.32,0,0,1,.727-1.759.38.38,0,0,0-.008-.446l-.757-1,.467-.467.467-.467,1,.757h0a.379.379,0,0,0,.433.016,5.355,5.355,0,0,1,1.771-.733ZM23.69,14.17a3.528,3.528,0,1,1-1.033,2.495A3.528,3.528,0,0,1,23.69,14.17Zm2.495-.273a2.768,2.768,0,1,1-1.957.811,2.768,2.768,0,0,1,1.957-.811ZM6.913,24.508a.38.38,0,1,1,0-.761H13.57a.38.38,0,1,1,0,.761Z",
    transform: "translate(170 2943.433)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLi3);
export default __webpack_public_path__ + "static/media/li3.184e7854b38151bdeed52d6db8d3311b.svg";
export { ForwardRef as ReactComponent };